const initialstate = {
    data:[],
    
}

const AdminDonorlist =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
                       default :
            return state;
    }
};
export default AdminDonorlist;